import React from 'react';
import { PictoProps } from '../index';

export const Burger = (props: PictoProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="4" width="17" height="2" rx="1" fill={props.fill || '#CCCBCB'} />
    <rect x="1.5" y="9" width="17" height="2" rx="1" fill={props.fill || '#CCCBCB'} />
    <rect x="1.5" y="14" width="17" height="2" rx="1" fill={props.fill || '#CCCBCB'} />
  </svg>
);
